module.exports = {
  GST_RATE: 0.05,
  PST_RATE: 0.10,
  API_ENDPOINT: window.location.protocol === 'https:' ? "https://api-sagrada.herokuapp.com" : "http://localhost:1110"
};
